import { useEffect } from 'react';
import { store } from "./store.js";
export function Example(_ref) {
  var {
    children
  } = _ref;
  useEffect(() => store.setExample(children), [children]);
  return null;
}